import script from "./DealsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DealsSection.vue?vue&type=script&setup=true&lang=js"

import "./DealsSection.vue?vue&type=style&index=0&id=5d5309bd&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5309bd"]])

export default __exports__